import React from 'react'

const Nutritionist = () => {
  return (
    <div id='nutritionist' className='nutritionist'>
        Nutritionist
    </div>
  )
}

export default Nutritionist